import { Link } from 'react-router-dom';
import type { JournalEntry } from '../../types/journal';

interface EntryListProps {
  entries: JournalEntry[];
}

function formatDate(isoString: string): string {
  const date = new Date(isoString);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

function renderRating(rating: number): string {
  const filled = '★'.repeat(rating);
  const empty = '☆'.repeat(5 - rating);
  return filled + empty;
}

export function EntryList({ entries }: EntryListProps) {
  return (
    <ul className="entry-list" role="list">
      {entries.map((entry) => (
        <li key={entry.entryId} className="entry-list-item">
          <Link
            to={`/journal/${entry.entryId}`}
            state={{ entry }}
            className="entry-list-link"
          >
            <span className="entry-date">{formatDate(entry.consumedAt)}</span>
            <span className="entry-cannabinoid">{entry.cannabinoidType}</span>
            <span className="entry-mg">{entry.cannabinoidMg} mg</span>
            {entry.recipeName && (
              <span className="entry-recipe">{entry.recipeName}</span>
            )}
            {entry.rating != null && (
              <span className="entry-rating" aria-label={`Rating: ${entry.rating} out of 5`}>
                {renderRating(entry.rating)}
              </span>
            )}
          </Link>
        </li>
      ))}
    </ul>
  );
}
